import pic21 from './assets/images/21.jpg';
import pic22 from './assets/images/22.jpg';
import pic23 from './assets/images/23.jpg';
import pic24 from './assets/images/24.jpg';

import svg11 from './assets/svg/11.svg';
import svg15 from './assets/svg/15.svg';
import svg21 from './assets/svg/21.svg';
import svg22 from './assets/svg/22.svg';

const Two = () => (
	<section>
		<div className="section-num" style={{top: 0}}>4</div>
		<p><img src={pic21} alt="" /></p>
		<div className="wrapper">
			<h2>Kdo žije v&nbsp;korunách?</h2>
			<p className="like-h3" style={{marginLeft: "", marginRight: ""}}>Koruny stromů jsou plné ptactva. Jen&nbsp;v&nbsp;Prochaskově lesoparku můžeš slyšet a vidět víc jak 60 druhů ptáků. Na polích a vinohradech, kde je stromů mnohem méně, jich potkáš jen&nbsp;polovinu.</p>
			<p className="txt-right" style={{marginBottom: ".5em"}}>
				<span className="relative inline-block" style={{maxWidth: "14em"}}>V lesoparku nejčastěji štěbetají sýkorky, brhlík, kos, pěnkava a zvonek.
					<img src={svg21} className="pointer" style={{top: "80%", right: "75%", maxWidth: "22%"}} alt="" />
				</span>
			</p>
		</div>
		<p><img src={pic22} alt="" /></p>
		<div className="wrapper">
			<p style={{marginTop: "-.75em"}}>
				<span className="relative inline-block" style={{maxWidth: "12.5em"}}>Po setmění tu možná uslyšíš houkat puštíka nebo výra.
					<img src={svg22} className="pointer" style={{bottom: "85%", left: "88%", maxWidth: "18%"}} alt="" />
				</span>
			</p>
			<h2>Kdo se nastěhoval na kmen?</h2>
			<p className="like-h3">Zvíře, které najde a obsadí prázdnou dutinu ve kmeni, vyhrálo ve zvířecí loterii. Dutina ho ochrání před deštěm, zimou a nezvanými lupiči jako jsou kuny. Kromě ptáků v nich žijí taky netopýři, veverky a včely.</p>
			<p className="txt-right" style={{marginBottom: ".75em"}}>
				<span className="relative inline-block" style={{maxWidth: "18em"}}>Jedna z mála zvířat, která si umí ve kmeni udělat vlastní dutinu, jsou datel a strakapoud.
					<img src={svg15} className="pointer" style={{top: "105%", left: "20%", maxWidth: "8%"}} alt="" />
				</span>
			</p>
		</div>
		<p style={{marginBottom: ".75em"}}><img src={pic23} alt="" /></p>
		<div className="wrapper">
			<p><b className="tip">Tip pro tebe:</b> Prozkoumej z blízka kůru jasanu ztepilého, u kterého stojíš. Je plná lišejníků, pro které je strom místem, kde mohou v bezpečí růst svým pomalým tempem. Většina lišejníků povyroste za rok jen o pár milimetrů.</p>
			<h2>I u kořenů je&nbsp;hodně&nbsp;živo</h2>
			<p className="like-h3">Půda se nám může zdát jako nehostinné prostředí pro jakýkoliv život. Ve skutečnosti v ní žije více jak polovina všech živých organismů.</p>
			<p className="like-h3">Většina jich je ale tak malých, že&nbsp;je&nbsp;uvidíš až pod mikroskopem.</p>
			<p className="txt-right" style={{marginBottom: "1em"}}>
				<span className="relative inline-block" style={{maxWidth: "14.75em"}}>Pod tvýma nohama se to v půdě hemží brouky a jejich larvami, mravenci, stonožkami a drobnými roztoči.
					<img src={svg11} className="pointer" style={{top: "100%", right: "70%", maxWidth: "20%"}} alt=""/>
				</span>
			</p>
		</div>
		<p style={{marginBottom: ".5em"}}><img src={pic24} alt="" /></p>
		<div className="wrapper">
			<p>
				<span className="relative inline-block" style={{maxWidth: "17em"}}>Díky žížalím chodbičkám, které můžou<br />být i&nbsp;3&nbsp;metry hluboko, je půda plná kyslíku, dobře se do ní vsakuje voda a lépe v ní koření rostliny.
					<img src={svg22} className="pointer" style={{bottom: "90%", right: "20%", maxWidth: "12%"}} alt="" />
				</span>
			</p>
		</div>
	  </section>
);

export default Two;
